import { render, staticRenderFns } from "./standsOrganizer.vue?vue&type=template&id=7cca0d41&scoped=true"
import script from "./standsOrganizer.vue?vue&type=script&lang=js"
export * from "./standsOrganizer.vue?vue&type=script&lang=js"
import style0 from "./standsOrganizer.vue?vue&type=style&index=0&id=7cca0d41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cca0d41",
  null
  
)

export default component.exports